// Oppie article — copy-link share button.
// Progressive enhancement: without JS the WhatsApp/e-mail links still work and
// the copy button simply does nothing harmful.

const RESET_MS = 2000;

function flash(button, live) {
  const label = button.getAttribute('data-copied-label');
  button.classList.add('is-copied');
  if (live && label) {
    live.textContent = label;
  }
  window.setTimeout(() => {
    button.classList.remove('is-copied');
    if (live) {
      live.textContent = '';
    }
  }, RESET_MS);
}

async function copy(url) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(url);
    return;
  }
  // Fallback for non-secure contexts (e.g. local theme preview over http).
  const field = document.createElement('textarea');
  field.value = url;
  field.setAttribute('readonly', '');
  field.style.position = 'absolute';
  field.style.left = '-9999px';
  document.body.appendChild(field);
  field.select();
  document.execCommand('copy');
  document.body.removeChild(field);
}

document.querySelectorAll('[data-oppie-copy]').forEach((button) => {
  const live = button.querySelector('[data-copy-live]');
  button.addEventListener('click', async () => {
    const url = button.getAttribute('data-oppie-copy') || window.location.href;
    try {
      await copy(url);
      flash(button, live);
    } catch (error) {
      console.error('Kopiëren van de link is mislukt:', error);
    }
  });
});
